module.exports = __webpack_public_path__ + "static/media/barbara6.abc2167a.mp3";